import React from 'react';
import { ScheduledSendCreditTasksTable } from './ScheduledSendCreditTasksTable';

export const ScheduledSendCreditTasksList: React.FC = () => {
  return <ScheduledSendCreditTasksTable />;
};
